<template>
    <div class="page-container">
        <!-- 智慧产品矩阵 -->
        <!-- <div class="matrix-container">
            <div class="matrix-header">
                <h2>全方位的农业数智化解决方案</h2>
                <p>为不同园区、棚型、作物等场景提供专业的智能化产品与服务</p>
            </div>
            <div class="matrix-wrapper">
                <el-row class="matrix-row" :gutter="30">
                    <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8" :xxl="8" class="matrix"
                        v-for="(service) in services" :key="service.title">
                        <div class="matrix-card">
                            <div class="matrix-image-container">
                                <img :src="service.image" class="matrix-image" :alt="service.title">
                            </div>
                            <div class="matrix-text-content">
                                <h3 class="matrix-title">{{ service.title }}</h3>
                                <p class="matrix-description">{{ service.description }}</p>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div> -->

        <!-- 智能产品 -->
        <div class="smart-container">
            <div class="matrix-header">
                <h2>硬件产品</h2>
            </div>
            <div class="smart-wrapper">
                <el-row class="smart-row" :gutter="30">
                    <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8" :xxl="8" class="smart-item" v-for="item in smart"
                        :key="item.title">
                        <div class="smart-card">
                            <div class="smart-image-container">
                                <img :src="item.image" class="smart-image" :alt="item.title">
                            </div>
                            <div class="smart-text-content">
                                <h3 class="smart-title">{{ item.title }}</h3>
                                <p class="smart-description">{{ item.description }}</p>
                                <el-button type="text" class="smart-button" @click="goToTypicalcase(item.path)">
                                    了解详情
                                </el-button>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'MainHomepage',
    data() {
        return {
            services: [
                {
                    title: '智能芯片',
                    description: '自主研发的高性能芯片，支持多种农业场景的智能化控制和数据处理',
                    image: require('@/assets/images/MainHardware/znxp.png')
                },
                {
                    title: '云端管理',
                    description: '基于云计算的智能管理平台，实现农业生产全过程的数字化监控与决策',
                    image: require('@/assets/images/MainHardware/ydgl.png')
                },
                {
                    title: '数据安全',
                    description: '采用多重加密技术，确保农业生产数据的安全性与可靠性',
                    image: require('@/assets/images/MainHardware/sjaq.png')
                }
            ],
            smart: [
                {
                    title: '智能卷帘机自动止停器（旗舰版）',
                    description: '人在家中睡，一键起棉被！',
                    image: require('@/assets/images/MainHardware/jlj-qj.png'),
                    path: '/juanlianji-qi'
                },
                {
                    title: '智能卷帘机自动止停器（专业版）',
                    description: '人在家中睡，一键起棉被！',
                    image: require('@/assets/images/MainHardware/jlj-zy.png'),
                    path: '/juanlianji-zy'
                },
                {
                    title: '芯棚到家智能放风机（旗舰版）',
                    description: '温控数据全知晓    智能放风护苗好',
                    image: require('@/assets/images/MainHardware/ffj-qj.png'),
                    path: '/FangfengjiDetails'
                },
                {
                    title: '智能水肥一体机系列',
                    description: '省水省肥又省力 增产增收不是梦',
                    image: require('@/assets/images/MainHardware/sfytj.png'),
                    path: '/ShuifeijiDetails'
                },
                {
                    title: '智能环境监测站系列',
                    description: '数据实时在手  预警分秒必达',
                    image: require('@/assets/images/MainHardware/hjjcz.png'),
                    path: '/HuanjingjianceDetails'
                },
                {
                    title: '多参数温室环境传感器系列',
                    description: '多参数精准感知  重塑环境监测新高度',
                    image: require('@/assets/images/MainHardware/wscgq.png'),
                    path: '/CanshuDetails'
                }
            ]
        }
    },
    methods: {
        goToTypicalcase(path) {
            this.$router.push(path);
        }
    },
}
</script>

<style scoped>
.page-container {
    width: 100%;
    background-color: rgba(216, 216, 216, 0.2);
    overflow-x: hidden;
}

/* 智慧产品矩阵样式 */
.matrix-container {
    width: 100%;
    max-width: 1920px;
    margin: 0 auto;
    padding: 60px 20px;
    box-sizing: border-box;
}

.matrix-header {
    text-align: center;
    margin-bottom: 64px;
}

.matrix-header h2 {
    text-align: center;
    margin-bottom: 16px;
    font-family: 'Alibaba_PuHuiTi_2.0_55_Regular_55_Regular';
    font-size: 32px;
    font-weight: 600;
    line-height: 36px;
    color: #111827;
}

.matrix-header p {
    font-family: 'Alibaba_PuHuiTi_2.0_55_Regular_55_Regular';
    font-size: 18px;
    font-weight: normal;
    line-height: 24px;
    text-align: center;
    color: #4B5563;
}

.matrix-wrapper {
    width: 100%;
    margin: 0 auto;
    overflow: hidden;
}

.matrix-row {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
}

.matrix {
    min-width: 0;
    box-sizing: border-box;
    margin-bottom: 30px;
}

.matrix-card {
    background-color: #ffffff;
    border-radius: 0.5rem;
    padding: 24px;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
    transition: box-shadow 150ms cubic-bezier(0.4, 0, 0.2, 1);
    height: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
}

.matrix-card:hover {
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}

.matrix-image-container {
    width: 100%;
    border-radius: 0.5rem;
    overflow: hidden;
    margin-bottom: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.matrix-image {
    max-width: 64px;
    max-height: 64px;
    object-fit: contain;
}

.matrix-text-content {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    text-align: center;
}

.matrix-title {
    margin-bottom: 12px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-family: 'Alibaba_PuHuiTi_2.0_55_Regular_55_Regular';
    font-size: 18px;
    font-weight: 550;
    line-height: 28px;
    color: #111827;
    margin-top: 0;
}

.matrix-description {
    margin-bottom: 16px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    font-family: 'Alibaba_PuHuiTi_2.0_55_Regular_55_Regular';
    font-size: 16px;
    font-weight: normal;
    line-height: 24px;
    color: #4B5563;
    flex-grow: 1;
}


.smart-container {
    width: 100%;
    max-width: 1920px;
    padding: 10px 20px 60px;
    box-sizing: border-box;
    margin: 0 auto;
}

.smart-wrapper {
    width: 100%;
}

.smart-row {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    box-sizing: border-box;
    justify-content: center;
    margin: 0 !important;
}

.smart-item {
    box-sizing: border-box;
    margin-bottom: 30px;
    display: flex;
    justify-content: center;
}

.smart-card {
    background-color: #ffffff;
    border-radius: 0.5rem;
    padding: 24px;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
    transition: box-shadow 150ms cubic-bezier(0.4, 0, 0.2, 1);
    height: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    width: 100%;
}

.smart-card:hover {
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}

.smart-image-container {
    width: 100%;
    height: 280px;
    border-radius: 0.5rem;
    overflow: hidden;
    margin-bottom: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.smart-image {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
}

.smart-text-content {
    width: 100%;
    box-sizing: border-box;
    flex: 1;
    display: flex;
    flex-direction: column;
}

.smart-title {
    margin-bottom: -12px;
    font-family: 'Alibaba_PuHuiTi_2.0_55_Regular_55_Regular';
    font-size: 18px;
    font-weight: 550;
    line-height: 28px;
    color: #111827;
    margin-top: 0;
}

.smart-description {
    margin: 20px 0;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    font-family: 'Alibaba_PuHuiTi_2.0_55_Regular_55_Regular';
    font-size: 16px;
    font-weight: normal;
    line-height: 24px;
    color: #4B5563;
    flex-grow: 1;
}

.smart-button {
    display: flex;
    align-items: center;
    white-space: nowrap;
    background: none;
    border: none;
    padding: 0;
    font-size: 16px;
    cursor: pointer;
    transition: color 150ms cubic-bezier(0.4, 0, 0.2, 1);
    margin-top: auto;
    font-family: 'Alibaba_PuHuiTi_2.0_55_Regular_55_Regular';
    font-weight: 400;
    font-size: 16px;
    color: #fff;
    width: 112px;
    height: 40px;
    background-color: #2563EB;
    justify-content: center;
    border-radius: 4px;
}

.smart-button:hover {
    color: #1d4ed8;
    background-color: transparent;
    border: 1px solid #2563EB;
}

/* 手机设备样式 (小于768px) */
@media (max-width: 767px) {
    .matrix-container {
        padding: 40px 15px;
    }

    .matrix-header {
        margin-bottom: 40px;
    }

    .matrix-header h2 {
        font-size: 24px;
        line-height: 32px;
    }

    .matrix-header p {
        font-size: 16px;
        line-height: 22px;
    }

    .matrix-card {
        padding: 16px;
    }

    .matrix-image {
        max-width: 50px;
        max-height: 50px;
    }

    .matrix-title {
        font-size: 16px;
        line-height: 24px;
    }

    .matrix-description {
        font-size: 14px;
        line-height: 20px;
    }

    .smart-container {
        padding: 10px 15px 40px;
    }

    .smart-image-container {
        height: 200px;
    }

    .smart-title {
        font-size: 16px;
        line-height: 24px;
        margin-bottom: 6px;
    }

    .smart-description {
        font-size: 14px;
        line-height: 20px;
    }

    .smart-button {
        width: 100px;
        height: 36px;
        font-size: 14px;
    }
}

/* 平板设备样式 (768px - 1023px) */
@media (min-width: 768px) and (max-width: 1023px) {
    .matrix-header h2 {
        font-size: 28px;
        line-height: 34px;
    }

    .matrix-header p {
        font-size: 17px;
        line-height: 23px;
    }

    .smart-image-container {
        height: 240px;
    }

    .el-col-sm-24 {
        width: 50% !important;

    }
}

/* 大屏幕设备样式 (2560px - 3839px) */
@media (min-width: 2560px) and (max-width: 3839px) {
    .matrix-container {
        max-width: 2400px;
        padding: 80px 30px;
    }

    .matrix-header {
        margin-bottom: 80px;
    }

    .matrix-header h2 {
        font-size: 42px;
        line-height: 48px;
    }

    .matrix-header p {
        font-size: 24px;
        line-height: 32px;
    }

    .matrix-card {
        padding: 32px;
    }

    .matrix-image {
        max-width: 80px;
        max-height: 80px;
    }

    .matrix-title {
        font-size: 24px;
        line-height: 32px;
        margin-bottom: 16px;
    }

    .matrix-description {
        font-size: 20px;
        line-height: 28px;
    }

    .smart-container {
        max-width: 2400px;
        padding: 20px 30px 80px;
    }

    .smart-row {
        gutter: 40;
    }

    .smart-card {
        padding: 32px;
    }

    .smart-image-container {
        height: 360px;
    }

    .smart-title {
        font-size: 24px;
        line-height: 32px;
    }

    .smart-description {
        font-size: 20px;
        line-height: 28px;
    }

    .smart-button {
        width: 130px;
        height: 48px;
        font-size: 18px;
    }
}

/* 超大型屏幕设备样式 (3840px及以上) */
@media (min-width: 3840px) {
    .matrix-container {
        max-width: 3200px;
        padding: 100px 40px;
    }

    .matrix-header {
        margin-bottom: 100px;
    }

    .matrix-header h2 {
        font-size: 52px;
        line-height: 60px;
    }

    .matrix-header p {
        font-size: 30px;
        line-height: 40px;
    }

    .matrix-card {
        padding: 40px;
    }

    .matrix-image {
        max-width: 100px;
        max-height: 100px;
    }

    .matrix-title {
        font-size: 30px;
        line-height: 40px;
        margin-bottom: 20px;
    }

    .matrix-description {
        font-size: 24px;
        line-height: 34px;
    }

    .smart-container {
        max-width: 3200px;
        padding: 20px 40px 100px;
    }

    .smart-row {
        gutter: 50;
    }

    .smart-card {
        padding: 40px;
    }

    .smart-image-container {
        height: 450px;
    }

    .smart-title {
        font-size: 30px;
        line-height: 40px;
    }

    .smart-description {
        font-size: 24px;
        line-height: 34px;
    }

    .smart-button {
        width: 150px;
        height: 56px;
        font-size: 22px;
    }
}
</style>